import { DesktopOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useIntl } from '@umijs/max';
import { Tooltip } from 'antd';
import { createStyles } from 'antd-style';
import React from 'react';
import { useThemeMode, type ThemeMode } from '@/hooks/useThemeMode';

const useStyles = createStyles(({ token }) => ({
  action: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 28,
    padding: '0 8px',
    cursor: 'pointer',
    borderRadius: token.borderRadius,
    fontSize: 16,
    '&:hover': {
      backgroundColor: token.colorBgTextHover,
    },
  },
}));

// 三态循环：跟随系统 → 亮色 → 暗色 → 跟随系统
const NEXT_MODE: Record<ThemeMode, ThemeMode> = {
  system: 'light',
  light: 'dark',
  dark: 'system',
};

const ICONS: Record<ThemeMode, React.ReactNode> = {
  system: <DesktopOutlined />,
  light: <SunOutlined />,
  dark: <MoonOutlined />,
};

const LABELS: Record<ThemeMode, { id: string; defaultMessage: string }> = {
  system: { id: 'app.theme.system', defaultMessage: '跟随系统' },
  light: { id: 'app.theme.light', defaultMessage: '亮色模式' },
  dark: { id: 'app.theme.dark', defaultMessage: '暗色模式' },
};

export const ThemeSwitch: React.FC = () => {
  const { styles } = useStyles();
  const { mode, setMode } = useThemeMode();
  const intl = useIntl();

  return (
    <Tooltip title={intl.formatMessage(LABELS[mode])}>
      <span
        className={styles.action}
        role="button"
        tabIndex={0}
        aria-label={intl.formatMessage(LABELS[mode])}
        onClick={() => setMode(NEXT_MODE[mode])}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setMode(NEXT_MODE[mode]);
          }
        }}
      >
        {ICONS[mode]}
      </span>
    </Tooltip>
  );
};

export default ThemeSwitch;
